// 自定义 web component simple-accordion
class SimpleAccordion extends HTMLElement {
  constructor() {
    super();
    // singleMode: 一次只能同时展开一项
    this.singleMode = this.hasAttribute("data-single-mode");
    this.isFooter = this.hasAttribute("data-footer");  
    this.items = this.querySelectorAll("[data-accordion-item]");
    this.expandFirst = this.hasAttribute("data-expand-first");
  }
  connectedCallback() {
    this.items.forEach((item, index) => {
      const content = item.querySelector("[data-accordion-content]");
      const button = item.querySelector("button");
      console.log(this.isFooter, window.matchMedia("(min-width: 750px)").matches);
      if(this.isFooter && window.matchMedia("(min-width: 750px)").matches){
        this.expandItem(item, content, index);
        
      }else{
        if (index === 0 && this.expandFirst) {
          this.expandItem(item, content, index);
        }
        button.addEventListener("click", () => {
          if (this.singleMode) {
            this.items.forEach((_item) => {
              const _content = _item.querySelector("[data-accordion-content]");
              this.collapseItem(_item, _content);
            });
          }
          if (content.style.maxHeight) {
            if (!this.singleMode) {
            }
              this.collapseItem(item, content);
          } else {
            this.expandItem(item, content, index);
          }
        });
     }
    });
  }

  expandItem(item, content, index) {
    item.classList.add("active");
    content.style.maxHeight = content.scrollHeight + "px";
    this.dispatchEvent(
      new CustomEvent(
        "simple-accordion:expand",
        {
          detail: {
            index,
          },
        },
        {
          bubbles: true,
        }
      )
    );
  }
  collapseItem(item, content) {
    item.classList.remove("active");
    content.style.maxHeight = null;
  }
}
if (!customElements.get("simple-accordion")) {
  customElements.define("simple-accordion", SimpleAccordion);
}
